// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCOfRwVueOsDsG00BHR_jJIQx4Hv0A4DIc",
  authDomain: "main10-d1fc3.firebaseapp.com",
  projectId: "main10-d1fc3",
  storageBucket: "main10-d1fc3.firebasestorage.app",
  messagingSenderId: "255010863126",
  appId: "1:255010863126:web:bf8f00bcd9a3689457dd37",
  measurementId: "G-4MQ6BM3679"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics and export it
export const initializeAnalytics = async () => {
  try {
    // Check if analytics is supported in the current environment
    const analyticsSupported = await isSupported();
    
    if (analyticsSupported) {
      const analytics = getAnalytics(app);
      return analytics;
    } else {
      console.log("Firebase Analytics is not supported in this environment");
      return null;
    }
  } catch (error) {
    console.error("Error initializing Firebase Analytics:", error);
    return null;
  }
};

export default app;
